export function Rodape() {
  return (
    <footer className="foot">
      <div className="wrap">
        <p>
          <strong>Como ler estes números.</strong> Os valores são os que estão{' '}
          <em>destacados no XML</em> — o app não recalcula tributo, ele lê o que o emitente informou.
          Onde o documento não traz o campo, o valor aparece como zero.
        </p>
        <p>
          As divergências usam parâmetros configuráveis (alíquotas de transição CBS/IBS, percentual de
          retenção previdenciária, piso de retenção de PIS/COFINS/CSLL) e servem como triagem, não como
          apuração. Confira sempre contra a legislação vigente e o enquadramento do prestador.
        </p>
      </div>
    </footer>
  );
}
